import { BRAND_HAS_REWIND_OPE } from 'common/configuration/constants';

// add here the LegacyIDs of accounts for which rewind is pre-activated to test the functionality in production while the FF is setted to false
// You must declare the same ids in src/AppBundle/Controller/UserSpaceController.php in myFlashbackAction to exclude route from redirection if the FF is disabled
const TEST_ACCOUNTS: string[] = [
  //'Z20230809154025336371336',
  //'Z20250121144544705333329',
  //'Z20221003084051723213385',
  //'Z20251016070005821753855',
  //'Z20251023081634414474495',
  //'Z20130926102759707395347',
  //'Z20220511141504297595990'
];

export const displayRewind = (userId?: string | number) =>
  BRAND_HAS_REWIND_OPE || TEST_ACCOUNTS.includes(`${userId}`);
